
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"33","viewBox":"0 0 32 33","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.05 20.298c.457 1.09.986 2.82.986 4.983 0 1.212-.39 2.106-1.156 2.656-.516.37-1.179.557-1.97.557h-.04l-.038-.004c-1.3-.145-1.692-1.36-1.64-2.152a2.105 2.105 0 00-.064-.594c-.145-.561-.384-1.029-.964-2.159l-.027-.053c-.387-.755-.832-1.027-1.447-1.403-.525-.32-1.119-.683-1.76-1.384a8.24 8.24 0 01-.92-1.276 1.145 1.145 0 01-.138-.244l-.015-.026c-.014-.025-.033-.058-.053-.097l-.097-.181c-.556-.483-1.417-.474-1.94-.468H7.62c-.917 0-1.46-.359-1.752-.66-.409-.42-.624-1.013-.624-1.715V8.427c0-.504.063-1.232.618-1.733.518-.47 1.251-.523 1.758-.523h1.673c.411 0 .807-.177 1.309-.4.283-.126.604-.27.971-.398 1.726-.598 4.021-.876 7.225-.876l2.548-.003c.694 0 1.348.273 1.89.789.287.272.461.616.533 1.048.016.096.026.298.027.407.011.275-.029.535-.115.775a2.566 2.566 0 011.482.687c.493.47.764 1.124.764 1.84 0 .526-.166 1.022-.475 1.43.182.09.355.206.509.355.398.388.605.926.613 1.598.026.671-.208 1.255-.647 1.686.465.464.77 1.128.802 1.865.06 1.39-.945 2.567-2.246 2.642l-5.431.682z","fill":"#F33535","fill-rule":"evenodd"}})])
          )
        }
      }
    